export enum PassDeviceType {
    Type18 = 18,
    Type19 = 19,
    Type20 = 20,
    Type21 = 21,
  }